export default __webpack_public_path__ + "static/media/markopolo.b224e2e1.png";